@if (items().length) {
    <div class="mb-8">
        <button
            class="flex items-center gap-x-4 typo-xs text-text-mid-contrast"
            type="button"
            [attr.aria-controls]="panelId"
            [attr.aria-expanded]="expanded()"
            (click)="toggle()"
        >
            <span>{{ 'AI.THINKING.REASONING' | translate }}</span>
            <span class="separator-dot"></span>
            <span>
                {{
                    (items().length === 1
                        ? 'AI.THINKING.STEPS_COUNT_SING'
                        : 'AI.THINKING.STEPS_COUNT_PLUR'
                    ) | translate: { count: items().length }
                }}
            </span>
            <interacta-icon
                class="size-16 shrink-0"
                [icon]="
                    expanded() ? 'chevron-small-down' : 'chevron-small-right'
                "
            />
        </button>
        <ul
            class="mt-12 flex flex-col gap-y-8 ps-36 typo-xs text-text-mid-contrast"
            [attr.aria-label]="
                'AI.THINKING.ACCESSIBILITY.STEPS_LIST' | translate
            "
            [attr.hidden]="expanded() ? null : ''"
            [id]="panelId"
        >
            @for (item of items(); track item.id) {
                <li class="list-disc">
                    {{ item.label.key | translate: item.label.params }}
                </li>
            }
        </ul>
    </div>
}
